import { render } from "./IndexRetour.vue?vue&type=template&id=37952a78"
import script from "./IndexRetour.vue?vue&type=script&lang=js"
export * from "./IndexRetour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__